export class DateOnly{
   private date:string;
   public constructor(date:string){
        this.date = this.formatDateOnly(date)
   }
   private formatDateOnly(date:string){
        if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      throw new Error(`Invalid DateOnly format: ${date}`);
    }
    return date;
   }
   public getDateOnly(){
    return this.date;
   }
    
}
export class TimeOnly{
    private time:string;
    public constructor(time:string){
        this.time = this.formatTime(time);
    }
    private formatTime(time:string){
        if (!/^\d{2}:\d{2}(:\d{2})?$/.test(time)) {
      throw new Error(`Invalid TimeOnly format: ${time}`);
    }
        // Om sekunder saknas, lägg till ":00"
        return time.length === 5 ? time + ":00" : time;
    }
    public getTime(){
        return this.time;
    }
}
export const CombineDateAndTimeOnly = (date:string,time:string):Date => {
    const [year,month,day] = date.split("-").map(Number);
    const [hours,minutes,seconds] = time.split(":").map(Number);
    const parsedDate:Date = new Date(Date.UTC(year,month - 1,day,hours,minutes,seconds));
    return parsedDate;
}
